export class Calendar {
    public static getPastYears(range: number): number[] {
        let years: number[] = [];
        let currentYear = new Date().getFullYear();
        for (let i = 0; i <= range; i++) {
            years.push(currentYear - i);
        }

        return years;
    }
}
